var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDeal = function SvgDeal(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m15.3 7.573-8.098 8.024-.011.011c-.54.528-1.4.522-1.93-.015L.402 10.695A1.4 1.4 0 0 1 .41 8.724L8.481.718 8.518.68A2.56 2.56 0 0 1 10.162 0h4.463C15.385 0 16 .621 16 1.387l-.005 4.505a2.63 2.63 0 0 1-.696 1.681zm-2.394-3.412c0-.574-.461-1.04-1.03-1.04-.57 0-1.032.466-1.032 1.04s.462 1.04 1.031 1.04c.57 0 1.031-.465 1.031-1.04"
  })));
};
export default SvgDeal;